import { render, staticRenderFns } from "./ShiftLink.vue?vue&type=template&id=106e195c&"
import script from "./ShiftLink.vue?vue&type=script&lang=js&"
export * from "./ShiftLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports